export enum ModalType {
  modal = 'modal',
  aside = 'aside',
  dropdown = 'dropdown'
}
